import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AccessoriesService } from 'src/app/services/Accessories/accessory.service';
import { ApiService } from 'src/app/services/API/api.service';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'accessory-listing',
  templateUrl: './accessory-listing.component.html',
  styleUrls: ['./accessory-listing.component.scss'],
})
export class AccessoryListingComponent implements OnInit {
  @Input() accessoriesList: any;
  @Input() from: string;
  showMore = false;
  showMoreDesc = false;
  accDisclaimer =
    'Jeep Genuine Accessories are not applicable to all vehicle models. Every effort has been made to ensure part numbers and recommended fitment times are correct and accurate at the time of publication but cannot be guaranteed. Speak to your Jeep Dealer to confirm accessory suitability for your vehicle and formalise a quotation including material and fitment charges. Jeep Australia reserves the right to change and/or discontinue any accessory without notice, including prices, colours, content and specifications. You should consider the mass of your accessories and how this will impact the loading of your vehicle to ensure it will not exceed gross vehicle mass limits.';

  constructor(
    public accessoriesService: AccessoriesService,
    public globalService: GlobalService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {}
  /**
   *  Checks for overlapping accessories, if not overlapping then successfully add accessory. Publish event to one3D component to load 3D
   * @param accessory accessory to be added.
   * @param accessoryAddedInPack will have data of pack in which current accessory is already added.
   */
  addAccessory(accessory, accessoryAddedInPack) {
    let acc = this.globalService.addedAccessories.filter((el) => {
      return el.accessories_id == accessory.accessories_id;
    });
    if (acc.length > 0) return;
    if (accessoryAddedInPack.length > 0 && this.from != 'addons') {
      this.accessoriesService.handleOverlappingAccessories(
        accessory,
        accessoryAddedInPack[0]
      );
    } else {
      this.accessoriesService.addAccessory(accessory, this.from);
    }
  }
  /**
   *  Removes added accessory. Publish event to one3D component to remove accessory from 3D
   * @param accessory accessory to be removed
   */
  removeAccessory(accessory) {
    this.accessoriesService.removeAccessory(accessory);
  }

  viewDetails(accessory) {
    this.accessoriesList.map((el) => {
      el.subgroupAccessories.map((subAcc) => {
        if (accessory.accessories_id != subAcc.accessories_id) {
          subAcc.viewDetails = false;
        }
      });
    });
    accessory.viewDetails = !accessory.viewDetails;
    if (accessory.viewDetails) {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Accessories_Info_Open',
        accessory.marketing_name
      );
    } else {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Accessories_Info_Close',
        accessory.marketing_name
      );
    }

    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'accessorize_menu',
      eAct: this.globalService.viewInterior
        ? 'interior_description'
        : 'exterior_description',
      eVal: accessory.marketing_name,
      eLa4: this.globalService.viewInterior ? 'interior' : 'exterior',
      eLa5: accessory.subgroup_name,
    });
  }
  /**
   * return santized & secure string to render in innerhtml
   * @param text that needs to be sanitized
   * @returns 
   */
  getSanitizedDynamicText(text): string {
    const sanitizedText = this.sanitizer.bypassSecurityTrustHtml(text);
    return this.sanitizer.sanitize(SecurityContext.HTML, sanitizedText);
  }
}
